import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { TRANSITION_DURATION } from "../constants";
import { ReactComponent as Spiral } from "../assets/images/spiral.svg";

const Images = [
  require("../assets/images/slides/1.jpg").default,
  require("../assets/images/slides/2.jpg").default,
  require("../assets/images/slides/3.jpg").default,
  require("../assets/images/slides/4.jpg").default,
  require("../assets/images/slides/5.jpg").default,
];

const transition = {
  duration: TRANSITION_DURATION / 1000,
};

const variants = {
  show: {
    opacity: 1,
    transition,
  },
  hide: {
    opacity: 0,
    transition,
  },
};

const settings = {
  arrows: false,
  dots: false,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplay: true,
  autoplaySpeed: 4000,
  speed: 2000,
  fade: true,
};

const Slideshow = () => {
  const [showTransition, setShowTransition] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setShowTransition(false);
    }, TRANSITION_DURATION * 3);
  }, []);

  return (
    <>
      <AnimatePresence initial={false}>
        {showTransition && (
          <motion.div
            variants={variants}
            initial="hide"
            animate="show"
            exit="hide"
            className="deskop-transition"
          >
            <Spiral />
          </motion.div>
        )}
      </AnimatePresence>
      <div className="slideshow">
        <Slider {...settings}>
          {Images.map((src, index) => (
            <div key={index} className="slideshow__slide">
              <img src={src} alt="" />
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default Slideshow;
